"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbSelectList = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _shapes = require("../../skybase-core/shapes");

var _sbSelect = require("../sb-select");

var _sbOption = require("../sb-option");

var _sbOptgroup = require("../sb-optgroup");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @typedef skybase-components.sb-select-list#props
 *
 * @property {Array.<Object>} options
 * @property {String|Number} value
 */

/**
 * @name skybase-components.sb-select-list#SbSelectList
 * @function
 *
 * @param  {skybase-components.sb-select-list#props} props
 * @return {React.Component}
 */
var SbSelectList = /*#__PURE__*/function (_Component) {
  _inherits(SbSelectList, _Component);

  var _super = _createSuper(SbSelectList);

  function SbSelectList() {
    var _this;

    _classCallCheck(this, SbSelectList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "sbOption", function (option) {
      var description = option.description,
          key = option.key,
          label = option.label,
          value = option.value,
          rest = _objectWithoutProperties(option, ["description", "key", "label", "value"]);

      return /*#__PURE__*/_react.default.createElement(_sbOption.SbOption, _extends({}, rest, {
        value: value,
        key: key || value
      }), label || description);
    });

    _defineProperty(_assertThisInitialized(_this), "sbOptionGroups", function (opt) {
      return opt.map(function (option) {
        if (option.options && option.label) {
          var label = option.label,
              options = option.options,
              rest = _objectWithoutProperties(option, ["label", "options"]);

          return /*#__PURE__*/_react.default.createElement(_sbOptgroup.SbOptGroup, _extends({}, rest, {
            key: option.key || "opt-group-".concat((0, _v.default)()),
            label: label
          }), _this.sbOptionGroups(options));
        }

        return _this.sbOption(option);
      });
    });

    return _this;
  }

  _createClass(SbSelectList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          options = _this$props.options,
          inputRef = _this$props.inputRef,
          rest = _objectWithoutProperties(_this$props, ["options", "inputRef"]);

      return /*#__PURE__*/_react.default.createElement(_sbSelect.SbSelect, _extends({}, rest, {
        inputRef: inputRef
      }), this.sbOptionGroups(options));
    }
  }]);

  return SbSelectList;
}(_react.Component);

exports.SbSelectList = SbSelectList;

_defineProperty(SbSelectList, "propTypes", {
  options: _propTypes.default.arrayOf(_propTypes.default.object),
  inputRef: _shapes.PropTypeRef
});

_defineProperty(SbSelectList, "defaultProps", {
  options: [],
  inputRef: function inputRef() {}
});
//# sourceMappingURL=sb-select-list.js.map